import React from 'react';
import { Link } from 'react-router-dom';
import { CircleDot } from 'lucide-react';

function NotFound() {
  return (
    <div className="flex flex-col items-center justify-center py-16 text-center">
      <CircleDot className="w-16 h-16 text-primary-dark mb-6" aria-hidden="true" />
      <h1 className="text-4xl font-bold text-primary mb-4">Página não encontrada</h1>
      <p className="text-gray-600 text-lg mb-8">
        A página que você procura não existe ou foi movida.
      </p>
      <Link
        to="/"
        className="bg-primary-dark hover:bg-primary text-white font-semibold px-6 py-3 rounded-lg transition-colors focus:ring-2 focus:ring-yellow-400 focus:ring-offset-2 focus:outline-none"
      >
        Voltar para Home
      </Link>
    </div>
  );
}

export default NotFound;
